import { SocialPostType } from '@frontend/gql/social/graphql';

export const POST_TYPE_DISPLAY_NAME: Record<SocialPostType, string> = {
  INSTAGRAM_POST: 'Instagram Post',
  INSTAGRAM_REEL: 'Instagram Reel',
  INSTAGRAM_STORY: 'Instagram Story',
  TIKTOK_VIDEO: 'TikTok Video',
  YOUTUBE_VIDEO: 'YouTube Video',
  YOUTUBE_SHORT: 'YouTube Short',
  PINTEREST_PIN: 'Pinterest Pin',
} as const;

export const POST_TYPE_ORDER: readonly SocialPostType[] = [
  'INSTAGRAM_POST',
  'INSTAGRAM_REEL',
  'INSTAGRAM_STORY',
  'TIKTOK_VIDEO',
  'YOUTUBE_SHORT',
  'YOUTUBE_VIDEO',
  'PINTEREST_PIN',
] as const;

export const POST_TYPE_COLOR_GRADIENT = [
  '#3A495F',
  '#4E617E',
  '#61799E',
  '#8194B1',
  '#A0AFC5',
  '#C0CAD8',
  '#DFE4EC',
] as const;

// Get color based on position in POST_TYPE_ORDER
export const getPostTypeColor = (postType: SocialPostType): string => {
  const index = POST_TYPE_ORDER.indexOf(postType);
  return index >= 0 && index < POST_TYPE_COLOR_GRADIENT.length
    ? POST_TYPE_COLOR_GRADIENT[index]
    : '#8884d8';
};

// Convert SocialPostType to display name
export const getPostTypeDisplayName = (postType: SocialPostType): string => {
  return POST_TYPE_DISPLAY_NAME[postType];
};
